import config from '@/const/config';
import createInstance from '../http';
const { request } = createInstance(config.orderBaseUrl);

export default {
  preOrder: params => request.post(`/api/share-mall-gateway-order/1.0/preOrder`, params, { handleError: true }), // 预下单
  calcPreOrder: params => request.post(`/api/share-mall-gateway-order/1.0/calcPreOrder`, params), // 重算预订单
  submitOrder: params => request.post(`/api/share-mall-gateway-order/1.0/submitOrder`, params, { handleError: true }), // 提交订单
  queryOrderList: params => request.get(`/api/share-mall-gateway-order/1.0/queryOrderList`, { params }), // 订单列表
  getOrderDetail: params => request.get(`/api/share-mall-gateway-order/1.0/getOrderDetail`, { params }), // 订单详情
  confirmOrder: params => request.post(`/api/share-mall-gateway-order/1.0/confirmOrder`, params), // 确认收货
  cancelOrder: params => request.post(`/api/share-mall-gateway-order/1.0/cancelOrder`, params), // 取消订单
  queryLogisticList: params => request.get(`/api/share-mall-gateway-order/1.0/queryLogisticList`, { params }), // 查询物流信息
  uploadCertificate: params => request.post(`/api/share-mall-gateway-voucher/1.0/uploadVoucher`, params), // 上传更新凭证
  listCertificateInfo: params => request.get(`/api/share-mall-gateway-voucher/1.0/listVoucher`, { params }), // 查询凭证操作记录
  queryPayAccount: params => request.get(`/api/share-mall-gateway-voucher/1.0/queryPayAccount`, { params }), // 查询订单支付账号信息
  confirmRefund: params => request.post(`/api/share-mall-gateway-order/1.0/confirmRefund`, params), // 确认收到退款
  payOrder: params => request.post(`/api/share-mall-gateway-order/1.0/payOrder`, params), // 获取支付跳转信息
  queryAuditRecord: params => request.get(`/api/share-mall-gateway-cr/1.0/queryRelationAuditRecord`, { params }), // 查询客商关系审核记录(待开户)
  getContract: params =>
    request.get(
      // 'https://mock.qa.91jkys.com/api/project/mock/199/getContract',
      '/api/share-mall-gateway-order/1.0/getContract',
      {
        params
      }
    ),
  downloadOrderQua: params => request.post(`/api/share-mall-gateway-order/1.0/downloadOrderQua`, params), // 订单资质下载（商品首营、药检单）
  getOrderQua: params => request.post(`/api/share-mall-gateway-order/1.0/getOrderQua`, params), // 查看订单资质（商品首营、药检单）
  queryPayResult: params => request.post(`/api/trade-service/1.0.0/queryPayResult`, params), // 查询支付结果
};
